// @flow
import NoUserView from "./view";

export default NoUserView;



// WEBPACK FOOTER //
// ./src/home-page-view/no-user-view/index.js